// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__Sf-YH","insightsList":"newBusinessInsightsMenu_insightsList__2MTvV","active":"newBusinessInsightsMenu_active__2tk5v"};